module.exports = __webpack_public_path__ + "img/usericon.df073325.png";